import * as a from '@mitranim/js/all.mjs'
import * as ut from './util-text.mjs'
import * as uc from './util-coll.mjs'
import * as um from './util-misc.mjs'

/*
Lexicon: "sel" is short for "selectable".
This file is for utils dedicated to selectables.
*/

// Redundant with field validation in `UiSelectable`.
// Should be kept in sync.
export function isSelectable(val) {return a.isObj(val) && (`value` in val || `title` in val)}
export function reqSelectable(val) {return a.req(val, isSelectable)}
export function optSelectable(val) {return a.opt(val, isSelectable)}

export function isValidSelectable(val) {return isSelectable(val) && a.isKey(val.value)}
export function reqValidSelectable(val) {return a.req(val, isValidSelectable)}
export function optValidSelectable(val) {return a.opt(val, isValidSelectable)}

/*
TODO remove. Structural equality is impractical in JS.
Prefer primitive values.
*/
export function isSelValAmong(vals, sel) {
  return a.some(vals, a.bind(uc.equiv, sel.value))
}

/*
TODO remove. Structural equality is impractical in JS.
Prefer primitive values.
*/
export function selByVal(sels, val) {
  return a.find(sels, sel => uc.equiv(sel.value, val))
}

export function selsByVals(sels, vals) {
  vals = a.setFrom(vals)
  return a.filter(sels, sel => vals.has(sel.value))
}

/*
Assumes the input is `snake_case`. Should be used for enums, such as the
ones fetched from the server.
*/
export function enumStringsToSelectables(val) {
  return a.map(val, enumStringToSelectable)
}

function enumStringToSelectable(value) {
  return {value, title: a.words(value).titleSpaced()}
}

/*
Takes and returns a collection of selectables, making titles unambiguous by
suffixing them with values. For example:

  [
    {value: `10`, title: `one`},
    {value: `20`, title: `one`},
  ]
  ->
  [
    {value: `10`, title: `one (10)`},
    {value: `20`, title: `one (20)`},
  ]

Implementation is suboptimal but shouldn't be our bottleneck.
*/
export function selDisambiguate(src) {
  const index = a.group(src, um.getTitle)

  function ambiguous(key) {return !key || a.len(index[a.reqKey(key)]) > 1}

  return a.map(src, function disambiguate(val) {
    return {
      value: val.value,
      title: (
        ambiguous(val.title)
        ? a.spaced(val.title, ut.parenthesize(val.value))
        : val.title
      ),
    }
  })
}

export function selTitle(src) {return src?.title || src?.value}
